// Auth0 has been removed from crosure-lite-studio (it's a frontend skeleton —
// all auth lives in Studio). This stub keeps existing call-sites compiling
// without changing their shapes. When per-tenant auth is reintroduced, it
// will come from @crosure/auth + the tenant's auth topology, NOT from Auth0.

export interface StubUser {
	sub?: string
	name?: string
	email?: string
}

export interface UseUserResult {
	user: StubUser | null
	error: Error | undefined
	isLoading: boolean
}

export function useUser(): UseUserResult {
	return { user: null, error: undefined, isLoading: false }
}
